module.exports = __webpack_public_path__ + "static/GraphiQL-docs-f365690ad8b9f2cea7c5decd3e6fad11.png";